/* eslint-disable react/destructuring-assignment */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkMenu, UitkMenuContainer, UitkMenuList, UitkMenuTrigger, PositionType } from 'uitk-react-menu';
import { ClickTracker } from 'bernie-analytics';
import * as React from 'react';
import { inject } from 'mobx-react';
import { UitkTertiaryButton } from 'uitk-react-button';
import { UitkSpacing } from 'uitk-react-spacing';
import { HeaderAccountMenu } from '../..';
var AnchorLinkTracked = ClickTracker('a');
var HeaderNavToolbar = /** @class */ (function (_super) {
    __extends(HeaderNavToolbar, _super);
    function HeaderNavToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderNavToolbar.prototype.render = function () {
        var _a = this.props, globalComponentsContext = _a.globalComponentsContext, analytics = _a.analytics, page = _a.page, menuLinks = _a.menuLinks, numberOfLinks = _a.numberOfLinks;
        var l10n = globalComponentsContext.header.l10n;
        if (!menuLinks || !menuLinks.sectionData) {
            return null;
        }
        var links = [];
        if (numberOfLinks > 0) {
            links = menuLinks && menuLinks.sectionData
                ? menuLinks.sectionData
                    .filter(function (s) { return s.type === 'link'; })
                    .slice(0, numberOfLinks)
                : [];
        }
        else {
            links = menuLinks.sectionData;
        }
        return links.map(function (link, linkIndex) {
            if (!link || !(link.text || link.iconName)) {
                return null;
            }
            if (link.type === 'menu') {
                if (link.id === 'memberProfileGuest'
                    || link.id === 'memberProfileSignedIn') {
                    return (React.createElement(HeaderAccountMenu, { analytics: analytics, page: page, l10n: l10n, position: PositionType.RIGHT, menu: link, menuTriggerLabelText: l10n.accountMyAccountLinkText }));
                }
                // eslint-disable-next-line react/no-array-index-key
                return React.createElement(SubSecondaryMenuItems, { link: link, key: linkIndex });
            }
            // eslint-disable-next-line react/no-array-index-key
            return React.createElement(MenuItems, { link: link, key: linkIndex });
        });
    };
    HeaderNavToolbar = __decorate([
        inject('analytics', 'page', 'globalComponentsContext')
    ], HeaderNavToolbar);
    return HeaderNavToolbar;
}(React.Component));
export { HeaderNavToolbar };
var SubSecondaryMenuItems = /** @class */ (function (_super) {
    __extends(SubSecondaryMenuItems, _super);
    function SubSecondaryMenuItems(props) {
        var _this = _super.call(this, props) || this;
        _this.subSecondaryMenuItems = _this.props.link.data.map(function (sublinks) { return ({
            className: 'uitk-list-item',
            label: sublinks.text,
            href: sublinks.url,
            typeAnchor: true,
            attributes: {
                role: 'menuItem',
                tabindex: 0
            }
        }); });
        _this.state = {
            isOpen: false
        };
        _this.toggleMenu = _this.toggleMenu.bind(_this);
        return _this;
    }
    SubSecondaryMenuItems.prototype.toggleMenu = function () {
        var isOpen = this.state.isOpen;
        this.setState({
            isOpen: !isOpen
        });
    };
    SubSecondaryMenuItems.prototype.render = function () {
        return (React.createElement("div", { className: "subSecondaryMenuItems" },
            React.createElement(UitkMenu, { isOpen: this.state.isOpen, onTriggerClick: this.toggleMenu },
                React.createElement(UitkMenuTrigger, null,
                    React.createElement(UitkTertiaryButton, { className: "global-navigation-nav-button" },
                        React.createElement(UitkIcon, { name: "expand_more", size: UitkIconSize.SMALL }),
                        this.props.link.text)),
                React.createElement(UitkMenuContainer, null,
                    React.createElement(UitkMenuList, { items: this.subSecondaryMenuItems })))));
    };
    return SubSecondaryMenuItems;
}(React.Component));
export { SubSecondaryMenuItems };
export var MenuItems = function (_a) {
    var link = _a.link;
    var showAsIconOnly = link.iconName !== null && link.iconName !== '';
    if (showAsIconOnly) {
        var iconClass = (link.id || link.iconName) + "__icon";
        return (React.createElement(UitkSpacing, { padding: { inlinestart: 'two', inlineend: 'four', block: 'three' } },
            React.createElement("div", { className: "header-links__item" },
                React.createElement(AnchorLinkTracked, { events: "click", href: link.url, rfrr: link.trackingEvent ? link.trackingEvent : null, rel: link.newWindow ? 'noopener' : null, target: link.newWindow ? '_blank' : '_self', tabIndex: 0, linkName: link.text },
                    React.createElement(UitkIcon, { name: link.iconName, className: iconClass }),
                    React.createElement("span", { className: "is-visually-hidden" }, link.text)))));
    }
    return (React.createElement(UitkSpacing, { padding: { inlinestart: 'two', inlineend: 'four', block: 'three' } },
        React.createElement("div", { className: "header-links__item" },
            React.createElement(AnchorLinkTracked, { events: "click", href: link.url, rfrr: link.trackingEvent ? link.trackingEvent : null, rel: link.newWindow ? 'noopener' : null, target: link.newWindow ? '_blank' : '_self', tabIndex: 0, linkName: link.text }, link.text))));
};
//# sourceMappingURL=header-nav-toolbar.js.map